import { render, staticRenderFns } from "./ReporteCapacitacionIndividual.vue?vue&type=template&id=4372d402"
import script from "./ReporteCapacitacionIndividual.vue?vue&type=script&lang=js"
export * from "./ReporteCapacitacionIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports